import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TrustProofSection() {
  return <section className="py-24 bg-gradient-to-br from-[#F0FFF4] to-white" data-id="element-346">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-347">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-348">
          <img src="https://cdn.magicpatterns.com/uploads/ndVsgh6cf4cVFhgpAqytm4/imgi_16_pdp_img7.jpg" alt="Trusted by 10,000+ Happy Customers" className="w-full h-auto" data-id="element-349" />
        </motion.div>

        {/* Additional trust indicators */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-350">
          {[{
          number: '12,847+',
          label: 'Happy Customers'
        }, {
          number: '4.9/5',
          label: 'Average Rating'
        }, {
          number: '90%',
          label: 'See Results in 2 Weeks'
        }, {
          number: '60-Day',
          label: 'Money Back Guarantee'
        }].map((stat, i) => <div key={i} className="text-center p-6 bg-white rounded-2xl shadow-lg border-2 border-[#10B981]/10" data-id="element-351">
              <div className="text-3xl font-bold text-[#10B981] mb-2" data-id="element-352">
                {stat.number}
              </div>
              <div className="text-sm text-[#374151] font-medium" data-id="element-353">
                {stat.label}
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}